import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "block text-xs font-semibold text-neutral-600 mb-3" }
const _hoisted_2 = { class: "flex flex-col space-y-2" }
const _hoisted_3 = {
  key: 0,
  class: "mt-6"
}

import { ref } from "vue";
import RadioGroup from "@/components/inputs/RadioGroup.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'CheckboxOption',
  props: {
	form: {
		type: Object,
	},
    value: {
        default: null,
        required: true,
    },
    label: {
        type: String,
        default: 'What type of checkbox field?',
    },
    error: {
        type: String,
        default: null,
    },
    disabled: {
        type: Boolean,
        default: false,
    },
},
  setup(__props) {

const props = __props;
const form = ref<object>(props.form);
const target = ref<string>('');

const checkbox_options = [
    { id: '1', label: 'As a Simple Binary Response (Yes/No)', value: 'binary', radioSelected: null},
    { id: '2', label: 'As Multiple Selection Options', value: 'multiple', radioSelected: null},
]



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("label", _hoisted_1, _toDisplayString(__props.label), 1),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(RadioGroup, {
        options: checkbox_options,
        name: "checkbox",
        modelValue: target.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((target).value = $event))
      }, null, 8, ["modelValue"])
    ]),
    (target.value == 'multiple')
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _renderSlot(_ctx.$slots, "default")
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})